import React from 'react';

const EditableContent = ({ control, isEditMode, value, name, ...otherProps }) => {
    let ContentComponent = control;
    return isEditMode ? <ContentComponent name={name} value={value} {...otherProps} /> : <span>{value}</span>;  
};

export default EditableContent;
